import { combineReducers } from 'redux';
import appReducer from './appReducer';
import authReducer from './authReducer';
import childReducer from './childReducer';

export default combineReducers({
    app : appReducer,
    auth : authReducer,
    childs : childReducer
});